import { render, staticRenderFns } from "./paperDialog.vue?vue&type=template&id=67ae3ea7"
import script from "./paperDialog.vue?vue&type=script&lang=js"
export * from "./paperDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports